import React, { useReducer, useRef } from 'react'
import { useDialogActions } from 'cityads-v3/hooks/dialog'
import { useThemeChanger } from 'cityads-v3/hooks/theme'
import classes from './HeaderTheme.scss'

import Brightness2OutlinedIcon from '@material-ui/icons/Brightness2Outlined'
import Brightness6OutlinedIcon from '@material-ui/icons/Brightness6Outlined'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import ThemeChanger from 'cityads-v3/components/ThemeChanger/ThemeChanger';
import WbSunnyOutlinedIcon from '@material-ui/icons/WbSunnyOutlined'

export default function HeaderTheme(): JSX.Element {
  const [open, setOpen, setClose] = useDialogActions()
  const anchorEl = useRef();
  const [, refresh] = useReducer(num => num + 1, 0)

  const { themeName } = useThemeChanger()
  const isSystem = window?.localStorage?.theme === 'system';

  return (
    <>
      <IconButton
        disableRipple
        edge="end"
        classes={{ root: classes.button }}
        ref={anchorEl}
        onClick={setOpen}
        size="small"
      >
        {!isSystem && themeName === 'light' ? <WbSunnyOutlinedIcon className={classes.icon} /> : null}
        {isSystem ? <Brightness6OutlinedIcon className={classes.icon} /> : null}
        {!isSystem && themeName === 'dark' ? <Brightness2OutlinedIcon className={classes.icon} /> : null}
      </IconButton>

      <Popover
        anchorEl={anchorEl.current}
        open={open}
        onClose={setClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <ThemeChanger onChange={refresh} />
      </Popover>
    </>
  )
}
